import { render, staticRenderFns } from "./vLogOut.vue?vue&type=template&id=24254d84&"
import script from "./vLogOut.vue?vue&type=script&lang=js&"
export * from "./vLogOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports